import { Component } from '@angular/core';
import { AbstractFieldDirective } from '../abstract-field.directive';
import { toBooleanValue } from '../../tool/field.function';

@Component({
  selector: 'app-boolean-field',
  templateUrl: './boolean-field.component.html',
  styleUrls: ['./boolean-field.component.scss']
})
export class BooleanFieldComponent extends AbstractFieldDirective {

  protected get value(): boolean {
    return this.field?.value === 'true';
  }

  protected updateValue(value?: null | boolean): void {
    if (!this.field)
      return;
    const newValue = toBooleanValue(value);
    if (this.field.value === newValue)
      return;
    this.field.value = newValue;
    this.fieldChange.emit(this.field);
  }

}
